export const gold = {
  1: { value: { base: '{colors.gold.light.1}', _dark: '{colors.gold.dark.1}' } },
  2: { value: { base: '{colors.gold.light.2}', _dark: '{colors.gold.dark.2}' } },
  3: { value: { base: '{colors.gold.light.3}', _dark: '{colors.gold.dark.3}' } },
  4: { value: { base: '{colors.gold.light.4}', _dark: '{colors.gold.dark.4}' } },
  5: { value: { base: '{colors.gold.light.5}', _dark: '{colors.gold.dark.5}' } },
  6: { value: { base: '{colors.gold.light.6}', _dark: '{colors.gold.dark.6}' } },
  7: { value: { base: '{colors.gold.light.7}', _dark: '{colors.gold.dark.7}' } },
  8: { value: { base: '{colors.gold.light.8}', _dark: '{colors.gold.dark.8}' } },
  9: { value: { base: '{colors.gold.light.9}', _dark: '{colors.gold.dark.9}' } },
  10: { value: { base: '{colors.gold.light.10}', _dark: '{colors.gold.dark.10}' } },
  11: { value: { base: '{colors.gold.light.11}', _dark: '{colors.gold.dark.11}' } },
  12: { value: { base: '{colors.gold.light.12}', _dark: '{colors.gold.dark.12}' } },
  a1: { value: { base: '{colors.gold.light.a1}', _dark: '{colors.gold.dark.a1}' } },
  a2: { value: { base: '{colors.gold.light.a2}', _dark: '{colors.gold.dark.a2}' } },
  a3: { value: { base: '{colors.gold.light.a3}', _dark: '{colors.gold.dark.a3}' } },
  a4: { value: { base: '{colors.gold.light.a4}', _dark: '{colors.gold.dark.a4}' } },
  a5: { value: { base: '{colors.gold.light.a5}', _dark: '{colors.gold.dark.a5}' } },
  a6: { value: { base: '{colors.gold.light.a6}', _dark: '{colors.gold.dark.a6}' } },
  a7: { value: { base: '{colors.gold.light.a7}', _dark: '{colors.gold.dark.a7}' } },
  a8: { value: { base: '{colors.gold.light.a8}', _dark: '{colors.gold.dark.a8}' } },
  a9: { value: { base: '{colors.gold.light.a9}', _dark: '{colors.gold.dark.a9}' } },
  a10: { value: { base: '{colors.gold.light.a10}', _dark: '{colors.gold.dark.a10}' } },
  a11: { value: { base: '{colors.gold.light.a11}', _dark: '{colors.gold.dark.a11}' } },
  a12: { value: { base: '{colors.gold.light.a12}', _dark: '{colors.gold.dark.a12}' } },
}
